import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import AccountMenuLoyaltyHasAccountDetailsTile from './AccountMenuLoyaltyHasAccountDetailsTile'
import AccountMenuLoyaltyDetailsTileSkeleton from './AccountMenuLoyaltyDetailsTileSkeleton'
import useLoyaltyUserEligibilityTier from 'loyalty/hooks/useLoyaltyUserEligibilityTier'
import AccountMenuLoyaltyNoAccountDetailsTiles from './AccountMenuLoyaltyNoAccountDetailsTiles'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import AccountMenuLoyaltyHasAccountDetailsTileNonMemberRegion from './AccountMenuLoyaltyHasAccountDetailsTileNonMemberRegion'
import useLoyaltyConfig from 'loyalty/hooks/useLoyaltyConfig'

interface Props {
  onLinkClick: () => void
}

function AccountMenuLoyaltyTiles({ onLinkClick }: Props) {
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const loyaltyAccount = useAppSelector(state => state.loyalty.account)
  const isCurrentRegionUserLoyaltyRegion = useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
  const [eligibilityTier, fetchingEligibility, fetchingEligibilityError] = useLoyaltyUserEligibilityTier()
  const [config, configFetching, configError] = useLoyaltyConfig()

  const showNoAccountDetailsTile =
    eligibilityTier &&
    !hasLoyaltyAccount &&
    !fetchingEligibility &&
    !fetchingEligibilityError

  if (loyaltyAccount.error || configError) {
    return null
  }

  if (loyaltyAccount.fetching || configFetching) {
    return <AccountMenuLoyaltyDetailsTileSkeleton />
  }

  return (
    <>
      {showNoAccountDetailsTile && config &&
        <AccountMenuLoyaltyNoAccountDetailsTiles
          eligibilityTier={eligibilityTier}
          onLinkClick={onLinkClick}
          config={config}
        />}
      {hasLoyaltyAccount && loyaltyAccount.data &&
        <>
          {isCurrentRegionUserLoyaltyRegion && <AccountMenuLoyaltyHasAccountDetailsTile
            onLinkClick={onLinkClick}
            loyaltyAccountData={loyaltyAccount.data}
          />}
          {!isCurrentRegionUserLoyaltyRegion && <AccountMenuLoyaltyHasAccountDetailsTileNonMemberRegion
            onLinkClick={onLinkClick}
            loyaltyAccountData={loyaltyAccount.data}
          />}
        </>}
    </>
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsLoyaltyEnabled)
})(AccountMenuLoyaltyTiles)
